var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 37,
    viewBox: "0 0 11 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#056363;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-244 -32)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(244 32)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(244 45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(244 58)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group1.a23f553691506cc0f5de495d86f16b76.svg";
export { ForwardRef as ReactComponent };